import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Card, CardActionArea, CardContent, Chip, CircularProgress, Container, Link, Stack, Typography } from '@mui/material';
import { listSessions } from './api';
import { useAsync } from './useAsync';

function PastSessions() {
    const { data: sessions, error } = useAsync(listSessions, 'Could not load past sessions. Is the backend running?');

    return (
        <Container maxWidth="sm" sx={{ py: 6 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: 1 }}>
                <Typography variant="h4" sx={{ fontWeight: 800 }}>Past sessions</Typography>
                <Link component={RouterLink} to="/live/host" underline="hover">Start a live quiz</Link>
            </Stack>
            <Typography color="text.secondary" sx={{ mb: 4 }}>Find a session you named earlier.</Typography>

            {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

            {!sessions && !error && <CircularProgress />}

            {sessions?.length === 0 && <Alert severity="info">No sessions yet.</Alert>}

            <Stack spacing={2}>
                {sessions?.map((session) => (
                    <Card key={session.sessionId} variant="outlined">
                        <CardActionArea component={RouterLink} to={`/live/host/${session.sessionId}`}>
                            <CardContent>
                                <Stack direction="row" justifyContent="space-between" alignItems="center">
                                    <Typography sx={{ fontWeight: 700 }}>{session.name}</Typography>
                                    <Chip label={session.status} size="small" color={['showing', 'revealed'].includes(session.status) ? 'success' : 'default'} />
                                </Stack>
                                <Typography variant="body2" color="text.secondary">
                                    {session.quizTitle} · {new Date(session.createdAt).toLocaleString()}
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                ))}
            </Stack>
        </Container>
    );
}

export default PastSessions;
